import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=2909afc8&scoped=true&"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js&"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSwitcher.vue?vue&type=style&index=0&id=2909afc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909afc8",
  null
  
)

export default component.exports